import {
  formatWallTime,
  normalizeLocalizationPreferences,
  todayInEventTimezone,
} from '@dinewise/utils';
import dayjs from 'dayjs';
import type { HomeReservation } from '~/routes/_index/fetch-home-reservations.server.ts';
import type { HomeEvent } from './home.types.ts';

const formatHostName = (host: HomeReservation['host']): string => {
  if (!host) {
    return '-';
  }

  const fullName = [host.firstName, host.lastName].filter(Boolean).join(' ').trim();

  return fullName.length > 0 ? fullName : '-';
};

type MapHomeEventArgs = {
  reservation: HomeReservation;
  locale?: string | null;
  timezone?: string | null;
};

export const mapHomeEvent = ({ reservation, locale, timezone }: MapHomeEventArgs): HomeEvent => {
  const { locale: resolvedLocale } = normalizeLocalizationPreferences({
    locale,
    timeZone: timezone,
  });
  const reservationDate = dayjs(reservation.date);
  const today = todayInEventTimezone(timezone);
  const isToday = reservation.date === today;

  return {
    id: reservation.id,
    title: reservation.eventName?.trim() || 'Untitled event',
    status: reservation.status,
    hostName: formatHostName(reservation.host || reservation.coordinator),
    timeLabel: formatWallTime(reservation.time, { locale: resolvedLocale }),
    guestCount: reservation.partySize,
    tripleseatId: reservation.tripleseatProviderId,
    dateLabel: isToday ? 'TOD' : reservationDate.format('MMM').toUpperCase(),
    dayOfMonth: reservationDate.format('D'),
  };
};

export const mapHomeEvents = (
  reservations: HomeReservation[],
  localization: Pick<MapHomeEventArgs, 'locale' | 'timezone'>,
): HomeEvent[] => reservations.map(reservation => mapHomeEvent({ reservation, ...localization }));
